import { render, staticRenderFns } from "./MemberContactDialog.vue?vue&type=template&id=597910bd&scoped=true&"
import script from "./MemberContactDialog.vue?vue&type=script&lang=js&"
export * from "./MemberContactDialog.vue?vue&type=script&lang=js&"
import style0 from "./MemberContactDialog.vue?vue&type=style&index=0&id=597910bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597910bd",
  null
  
)

export default component.exports